<template>
    <div class="brands">
        <ul class="brands-list">
            <li
                v-for="(brand, index) in brands"
                :key="brand.product_brand_id"
                :id="itemId(brand, index > 0 ? brands[index-1] : {})"
            >
                <a v-on:click="handleOnClick(brand)">{{ brand.product_brand_title }}</a>
            </li>
        </ul>
        <ul class="letters-list">
            <li v-for="letter in letters" :key="letter">
                <a v-on:click="scrollTo(letter)">{{ letter }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    import Mixins from '../../mixins/mixins.js';

    export default {
        props: {
            brands: Array,
            handleOnClick: Function
        },
        components: {
        },
        mixins: [Mixins],
        data() {
            return {
                letters: ['#', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
            }
        },
        computed: {
        },
        methods: {
            itemId(brand, previousBrand) {
                if (previousBrand.product_brand_title) {
                    return brand.product_brand_title.charAt(0) != previousBrand.product_brand_title.charAt(0) ?
                        brand.product_brand_title.charAt(0).toUpperCase() :
                        '';
                }
                return brand.product_brand_title.charAt(0) < 'a' ? '#' : brand.product_brand_title.charAt(0).toUpperCase();
            },
            scrollTo(letter) {
                let container = document.getElementById("searchContent");
                container.scrollTop = document.getElementById(letter)?.offsetTop;
            },
        },
        mounted() {
        },
    }
</script>

<style lang="scss" scoped>
.brands-list {
    border-top: 1px solid #F6F6F6;
    margin-right: 30px;

    li {
        align-items: center;
        border-bottom: 1px solid #F6F6F6;
        display: flex;
        font-size: 16px;
    }

    a {
        flex-grow: 1;
        padding: 14px 24px;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
}

.letters-list {
    display: flex;
    flex-flow: column;
    position: fixed;
    top: 51%;
    transform: translateY(-50%);
    width: 30px;
    right: 0;
    list-style: none;

    @media screen and (min-height: 800px) {
        top: 53%
    }

    li {
        text-align: center;
        border: none;

        a {
            color: #B0B0B0;
            font-size: 13px;
            line-height: 17.5px;
            padding: 0;

            @media screen and (min-height: 669px) {
                line-height: 20px;
            }
            @media screen and (min-height: 800px) {
                line-height: 21px;
            }
        }
    }
}
</style>
